export class topicMaster {
    topicId: string;
    topicName: string;
    isActive: string;
    displayOrder: string;
    totalRecords:string;
    encryTopicId:string;
    modifiedBy:string;
    createdBy:string;
}